import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ListadoExigencia = async (indicadorId, usuarioId) => {
    try {
        const resultado = await instance.Backend.post("/Hallazgo/ListadoExigencia", {
            indicadorId: indicadorId,
            idUsuario: usuarioId
        }, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ListadoExigencia };